import 'regenerator-runtime/runtime';
import Vue from 'vue';
import router from './router';
import store from './store';
import App from './App';

import './fontawesome';
import './validation';

import VuePhotoSwipe from './plugins/PhotoSwipe';
Vue.use(VuePhotoSwipe);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);

import lineClamp from 'vue-line-clamp';
Vue.use(lineClamp);

import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);
  
import VueProgressBar from 'vue-progressbar';
Vue.use(VueProgressBar, {
    color: '#783e93',
    failedColor: '#ff0000',
    thickness: '15px',
    // thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 100,
    },
    position: 'absolute',
});

// import Sticky from 'vue-sticky-directive'
// Vue.use(Sticky)

import TreeMenu from '@/components/TreeMenu';
Vue.component('tree-menu', TreeMenu);

import { apolloProvider } from './store/apollo';

import '@/init';
import '@/router/middleware';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    apolloProvider,
    render: (h) => h(App),
}).$mount('#app');
